import Vue from 'vue'
import { EVENTS } from '@/scripts/constants/css-classes'

const iFrameResize = (value, el) => {
  const document = el.contentWindow.document
  var lastHeight = null
  const update = () => {
    const currentHeight = document.body.parentElement.offsetHeight
    if (lastHeight !== currentHeight) {
      el.style.height = `${currentHeight}px`
      lastHeight = currentHeight
    }

    el.rafId = requestAnimationFrame(update)
  }

  el.rafId = requestAnimationFrame(update)
}

Vue.directive(EVENTS.RESIZE, {
  bind: function (el, { value = {} }) {
    el.addEventListener(EVENTS.LOAD, () => iFrameResize(value, el))
  },
  unbind: function (el) {
    cancelAnimationFrame(el.rafId)
  },
})
